<mat-icon [svgIcon]="svgIcon" />
<span>{{ text }}</span>
